import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api.js";

const PLATFORMS = [
  { id: "facebook", label: "Facebook Pages" },
  { id: "instagram", label: "Instagram" },
  { id: "tiktok", label: "TikTok" },
];

export function ConnectionsView() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["connections"], queryFn: api.connections });

  const oauthNotice = new URLSearchParams(window.location.search).get("oauth");

  return (
    <div>
      <h1>Connections</h1>
      {oauthNotice && <p className="muted">OAuth result: {oauthNotice}</p>}

      <div className="row" style={{ flexWrap: "wrap", margin: "1rem 0" }}>
        {PLATFORMS.map((p) => (
          <a key={p.id} href={api.oauthStartUrl(p.id)}>
            <button>Connect {p.label}</button>
          </a>
        ))}
      </div>

      {data?.items.length === 0 && <p className="muted">No accounts connected yet.</p>}
      {data?.items.map((c) => (
        <div key={c.id} className="card row" style={{ justifyContent: "space-between" }}>
          <div className="row">
            {c.avatarUrl && <img src={c.avatarUrl} width={36} height={36} style={{ borderRadius: "50%" }} />}
            <div>
              <div>
                <strong>{c.displayName}</strong> <span className="badge">{c.platform}</span>
              </div>
              <div className="muted">
                {c.status}
                {c.tokenExpiresAt ? ` · token expires ${new Date(c.tokenExpiresAt).toLocaleDateString()}` : ""}
                {c.lastError ? ` · ${c.lastError}` : ""}
              </div>
            </div>
          </div>
          <button
            onClick={async () => {
              await api.deleteConnection(c.id);
              qc.invalidateQueries({ queryKey: ["connections"] });
            }}
          >
            Disconnect
          </button>
        </div>
      ))}
    </div>
  );
}
